(function () {
  'use strict';

  /* ─── Helpers ───────────────────────────────────────── */
  function fmtMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

  /* ─── Thumbnail switcher ─────────────────────────── */
  var thumbs      = qsa('.gj-product__thumb');
  var featuredImg = qs('#gj-featured-image');

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (featuredImg) {
        featuredImg.style.opacity = '0.6';
        featuredImg.removeAttribute('srcset');
        featuredImg.removeAttribute('sizes');
        featuredImg.src = thumb.dataset.imageSrc;
        featuredImg.alt = thumb.dataset.imageAlt || '';
        featuredImg.onload = function() { featuredImg.style.opacity = '1'; };
      }
    });
  });

  /* ─── Qty stepper ────────────────────────────────── */
  var qtyInput = qs('#gj-qty-input');

  qsa('[data-qty-action]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (!qtyInput) return;
      var cur = parseInt(qtyInput.value, 10) || 1;
      var max = parseInt(qtyInput.max, 10) || 99;
      qtyInput.value = btn.dataset.qtyAction === 'minus'
        ? Math.max(1, cur - 1)
        : Math.min(max, cur + 1);
    });
  });

  /* ─── Product data ───────────────────────────────── */
  var variantsEl  = qs('#gj-product-variants-json');
  var productEl   = qs('#gj-product-json');
  if (!variantsEl || !productEl) return;

  var variants    = [];
  var productData = {};
  try { variants    = JSON.parse(variantsEl.textContent); } catch(e) {}
  try { productData = JSON.parse(productEl.textContent);  } catch(e) {}

  var variantIdInput  = qs('#gj-variant-id');
  var priceContainer  = qs('#gj-price');
  var atcBtn          = qs('#gj-atc-btn');
  var stickyAtcBtn    = qs('#gj-sticky-atc-btn');
  var stickyPrice     = qs('#gj-sticky-price');
  var stockBadge      = qs('#gj-stock-badge');
  var stockText       = qs('#gj-stock-text');

  function getSelectedOptions() {
    var opts = [];
    qsa('.gj-product__option').forEach(function(optEl) {
      var idx    = parseInt(optEl.dataset.optionIndex, 10);
      var radio  = optEl.querySelector('.gj-swatch__input:checked');
      var select = optEl.querySelector('.gj-product__select');
      if (radio)  opts[idx] = radio.value;
      else if (select) opts[idx] = select.value;
    });
    return opts;
  }

  function findVariant(opts) {
    return variants.find(function(v) {
      return opts.every(function(val, i) {
        return v['option' + (i + 1)] === val;
      });
    });
  }

  function updatePage(variant) {
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;
    if (stickyAtcBtn)   stickyAtcBtn.dataset.variantId = variant.id;

    /* Price */
    if (priceContainer) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html = '<span class="gj-product__price-compare">' + fmtMoney(variant.compare_at_price) + '</span>'
             + '<span class="gj-product__price gj-product__price--sale">' + fmtMoney(variant.price) + '</span>'
             + '<span class="gj-badge gj-badge--sale">Save ' + fmtMoney(variant.compare_at_price - variant.price) + '</span>';
      } else {
        html = '<span class="gj-product__price">' + fmtMoney(variant.price) + '</span>';
      }
      priceContainer.innerHTML = html;
    }

    if (stickyPrice) stickyPrice.textContent = fmtMoney(variant.price);
    updateBundleNote(variant.price);

    /* ATC state */
    if (atcBtn) {
      var textEl = atcBtn.querySelector('.gj-btn__text');
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.classList.remove('gj-btn--sold-out');
        if (textEl) textEl.textContent = 'Grab It';
      } else {
        atcBtn.disabled = true;
        atcBtn.classList.add('gj-btn--sold-out');
        if (textEl) textEl.textContent = "Gone. (We'll be back.)";
      }
    }

    /* Stock signals */
    var low = variant.inventory_management === 'shopify'
      && variant.inventory_quantity <= 5
      && variant.inventory_quantity > 0;
    if (stockBadge) { stockBadge.hidden = !low; if (low) stockBadge.textContent = 'Almost Gone. ' + variant.inventory_quantity + ' Left'; }
    if (stockText)  { stockText.hidden = !low;  if (low) stockText.textContent  = 'Almost Gone. Only ' + variant.inventory_quantity + ' bags left.'; }

    /* Image swap */
    if (variant.featured_image && featuredImg) {
      var src = variant.featured_image.src.replace(/(\.\w+)$/, '_900x$1');
      featuredImg.style.opacity = '0.6';
      featuredImg.removeAttribute('srcset');
      featuredImg.removeAttribute('sizes');
      featuredImg.src = src;
      featuredImg.alt = variant.featured_image.alt || '';
      featuredImg.onload = function() { featuredImg.style.opacity = '1'; };

      /* Keep thumbnail highlight in sync with variant image */
      var matchId = String(variant.featured_image.id);
      thumbs.forEach(function(t) {
        if (t.dataset.imageId === matchId) {
          t.classList.add('is-active');
        } else {
          t.classList.remove('is-active');
        }
      });
    }

    /* URL */
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(null, '', url.toString());
    }

    /* Variant price may differ - refresh ship-bar projection */
    if (typeof refreshShipPreview === 'function') refreshShipPreview();
  }

  /* Swatch change */
  qsa('.gj-swatch__input').forEach(function(input) {
    input.addEventListener('change', function() {
      var optEl = input.closest('.gj-product__option');
      if (optEl) {
        qsa('.gj-swatch', optEl).forEach(function(sw) { sw.classList.remove('is-selected'); });
        input.closest('.gj-swatch').classList.add('is-selected');
      }
      var m = findVariant(getSelectedOptions());
      if (m) updatePage(m);
    });
  });

  /* Select change */
  qsa('.gj-product__select').forEach(function(sel) {
    sel.addEventListener('change', function() {
      var m = findVariant(getSelectedOptions());
      if (m) updatePage(m);
    });
  });

  /* ─── Bundle picker ──────────────────────────────── */
  var bundleWrap  = qs('#gj-bundle');
  var bundleOpts  = qsa('.gj-bundle__opt');
  var bundleNote  = qs('#gj-bundle-price-note');
  var activeBundleQty      = 1;
  var activeBundleDiscount = 0;
  var currentCartTotal     = productData.cartTotal || 0; /* seeded from Liquid, synced from /cart.js */

  function tierTotalCents(opt, unitCents) {
    var fixed = parseInt(opt.getAttribute('data-fixed-price'), 10);
    if (!isNaN(fixed) && fixed > 0) return fixed;
    var qty  = parseInt(opt.getAttribute('data-qty'), 10) || 1;
    var disc = parseInt(opt.getAttribute('data-discount'), 10) || 0;
    var perBag = Math.round(unitCents * (1 - disc / 100));
    return perBag * qty;
  }

  function updateBundlePrices(unitPriceCents) {
    if (!unitPriceCents) return;
    bundleOpts.forEach(function(opt) {
      var onceEl = opt.querySelector('[data-gj-price-once]');
      if (onceEl) onceEl.textContent = fmtMoney(tierTotalCents(opt, unitPriceCents));
    });
  }

  function getSubUnitCents(variant, unitPriceCents) {
    if (!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations.length) return null;
    var alloc = variant.selling_plan_allocations[0];
    if (alloc && alloc.per_delivery_price != null) return alloc.per_delivery_price;
    if (alloc && alloc.price != null)              return alloc.price;
    return null;
  }

  function pluralBag(n) { return n === 1 ? 'bag' : 'bags'; }

  function updateBundleNote(unitPriceCents) {
    if (!bundleNote || !unitPriceCents) return;
    updateBundlePrices(unitPriceCents);
    var activeOpt = document.querySelector('.gj-bundle__opt--selected');
    var totalOnce = activeOpt ? tierTotalCents(activeOpt, unitPriceCents) : (unitPriceCents * activeBundleQty);
    var subQty   = activeOpt ? (parseInt(activeOpt.getAttribute('data-sub-qty'), 10) || activeBundleQty) : activeBundleQty;
    var isPack   = activeOpt && activeOpt.hasAttribute('data-pack-variant');
    var variant  = findVariant(getSelectedOptions());
    // Pack tiers subscribe on the pack's own plan; loose-bag tiers on the flavor variant's plan
    var hasSub   = isPack
      ? activeOpt.hasAttribute('data-pack-plan')
      : (variant && variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0);
    var subTotal = totalOnce;
    if (isPack) {
      var packSub = parseInt(activeOpt.getAttribute('data-pack-sub-price'), 10);
      if (!isNaN(packSub) && packSub > 0) subTotal = packSub;
    }
    // Jerk Club member benefit: same price, +bonus free bag(s) + free shipping.
    // Driven by data-sub-qty (member bag total), independent of any per-product plan.
    var bonus = subQty > activeBundleQty ? (subQty - activeBundleQty) : 0;
    var lines = [];
    if (activeBundleQty > 1) {
      lines.push(activeBundleQty + ' ' + pluralBag(activeBundleQty) + ' for ' + fmtMoney(totalOnce));
    }
    if (bonus > 0) {
      var perk = bundleNote.getAttribute('data-member')
        ? '🎁 Your Jerk Club perk: ' + subQty + ' ' + pluralBag(subQty) + ' (' + bonus + ' free) + free shipping'
        : '🎁 Jerk Club members get ' + subQty + ' ' + pluralBag(subQty) + ' (' + activeBundleQty + ' + ' + bonus + ' free) + free shipping';
      lines.push(perk);
    } else if (activeBundleQty >= 1) {
      lines.push(bundleNote.getAttribute('data-member')
        ? '🎁 Free shipping + a free bag — your Jerk Club perk'
        : '🎁 Jerk Club members: free shipping + a free bag every order');
    }
    bundleNote.innerHTML = lines.join('<br>');

    // Keep the free-bag picker's cap in sync with whichever tier is now active.
    var freebagBox = document.getElementById('gj-member-free-bag');
    if (freebagBox && freebagBox.updateFreeBagMax) freebagBox.updateFreeBagMax(bonus);
  }

  function projectedTotal() {
    var v = findVariant(getSelectedOptions());
    if (!v) return currentCartTotal;
    var discounted = Math.round(v.price * (1 - activeBundleDiscount / 100));
    return currentCartTotal + discounted * activeBundleQty;
  }

  function paintShipBar(totalCents) {
    var t = parseFloat(totalCents) || 0;
    var threshold = (productData && productData.freeShipThreshold) || 5900;
    var remaining = threshold - t;
    var textA = document.getElementById('gj-ship-nudge-text');
    var textB = document.getElementById('gj-drawer-ship-text');
    if (textA) textA.innerHTML = remaining <= 0
      ? 'Free shipping unlocked. Nice move.'
      : 'Add <strong>' + fmtMoney(remaining) + '</strong> more for free shipping';
    if (textB) textB.textContent = remaining <= 0
      ? 'Free shipping unlocked.'
      : 'Add ' + fmtMoney(remaining) + ' more for free shipping';
  }

  function refreshShipPreview() {
    paintShipBar(projectedTotal());
  }

  // Top-of-page price follows the selected tier (pack price), not the single-bag price
  function setTopPrice(opt) {
    if (!priceContainer || !opt) return;
    var fixed = parseInt(opt.getAttribute('data-fixed-price'), 10);
    var v = findVariant(getSelectedOptions());
    var cents = (!isNaN(fixed) && fixed > 0) ? fixed : (v ? v.price : 0);
    priceContainer.innerHTML = '<span class="gj-product__price">' + fmtMoney(cents) + '</span>';
  }

  /* Tier click swaps the main image to the pack product's image (3/5/Jerk Pack art) */
  function showTierImage(opt) {
    if (!featuredImg) return;
    var packImg = opt.getAttribute('data-pack-image');
    if (!packImg || featuredImg.src === packImg) return;
    featuredImg.style.opacity = '0.6';
    featuredImg.removeAttribute('srcset');
    featuredImg.removeAttribute('sizes');
    featuredImg.src = packImg;
    featuredImg.alt = opt.getAttribute('data-pack-image-alt') || featuredImg.alt;
    featuredImg.onload = function() { featuredImg.style.opacity = '1'; };
    thumbs.forEach(function(t) { t.classList.remove('is-active'); });
  }

  bundleOpts.forEach(function(opt) {
    opt.addEventListener('click', function() {
      bundleOpts.forEach(function(o) { o.classList.remove('gj-bundle__opt--selected'); });
      opt.classList.add('gj-bundle__opt--selected');
      activeBundleQty      = parseInt(opt.dataset.qty,      10) || 1;
      activeBundleDiscount = parseInt(opt.dataset.discount, 10) || 0;
      if (qtyInput) qtyInput.value = activeBundleQty;
      var currentVariant = findVariant(getSelectedOptions());
      if (currentVariant) updateBundleNote(currentVariant.price);
      setTopPrice(opt);
      showTierImage(opt);
      refreshShipPreview();
      // Let the flavor-mix selector resize to the new tier's bag count
      document.dispatchEvent(new CustomEvent('gj:tier', { detail: { qty: activeBundleQty } }));
    });
  });

  /* Initial paint + sync state from the default-selected tile (no single-bag tier) */
  (function() {
    var sel = document.querySelector('.gj-bundle__opt--selected');
    if (sel) {
      activeBundleQty      = parseInt(sel.dataset.qty,      10) || 1;
      activeBundleDiscount = parseInt(sel.dataset.discount, 10) || 0;
      if (qtyInput) qtyInput.value = activeBundleQty;
    }
    var v = findVariant(getSelectedOptions());
    if (v) updateBundleNote(v.price);
    if (sel) setTopPrice(sel);
    if (typeof refreshShipPreview === 'function') refreshShipPreview();
  })();

  /* ─── AJAX Cart ──────────────────────────────────── */
  function addToCart(variantId, qty, btnEl, sellingPlanId) {
    if (!variantId) return;
    if (btnEl) {
      btnEl.setAttribute('aria-busy', 'true');
      var tEl = btnEl.querySelector('.gj-btn__text'), lEl = btnEl.querySelector('.gj-btn__loading');
      if (tEl) tEl.hidden = true;
      if (lEl) lEl.hidden = false;
    }
    var payload = { id: variantId, quantity: qty || 1 };
    if (sellingPlanId) payload.selling_plan = parseInt(sellingPlanId, 10);
    var formEl = qs('#gj-product-form');
    if (formEl) {
      var props = {};
      formEl.querySelectorAll('[name^="properties["]').forEach(function(inp) {
        var m = inp.name.match(/^properties\[(.+)\]$/);
        if (m && inp.value) props[m[1]] = inp.value;
      });
      if (Object.keys(props).length > 0) payload.properties = props;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
    .then(function(r) { return r.json(); })
    // Recharge's cart drawer auto-opens on add; don't open the theme drawer too
    .then(function() { document.dispatchEvent(new CustomEvent('cart:refresh')); })
    .catch(function(e) { console.error('GJ cart error:', e); })
    .finally(function() {
      if (btnEl) {
        btnEl.removeAttribute('aria-busy');
        var tEl = btnEl.querySelector('.gj-btn__text'), lEl = btnEl.querySelector('.gj-btn__loading');
        if (tEl) { tEl.hidden = false; tEl.textContent = (sellingPlanId ? 'Subscribe & Save' : 'Grab It'); }
        if (lEl) lEl.hidden = true;
      }
    });
  }

  /* Form submit */
  var form = qs('#gj-product-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      // Read everything from the actual form (picks up Recharge's selling_plan + any subscription properties automatically)
      var planInput = form.querySelector('input[name="selling_plan"]');
      var plan = planInput ? planInput.value : '';
      var vid  = parseInt(variantIdInput ? variantIdInput.value : 0, 10);
      var qty  = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      // Pack tiers add the real fixed-price pack product (qty 1) instead of N loose bags.
      // The flavor rides along as a "Flavor Mix" line item property for fulfillment.
      var selOpt = document.querySelector('.gj-bundle__opt--selected');
      var packVid = selOpt ? selOpt.getAttribute('data-pack-variant') : null;
      if (packVid) {
        vid = parseInt(packVid, 10);
        qty = 1;
        // If the shopper chose Subscribe, swap in the pack's own selling plan (plan ids are per product)
        plan = plan ? (selOpt.getAttribute('data-pack-plan') || '') : '';
        // The flavor-mix selector owns the Flavor Mix property when present;
        // only fall back to the single-flavor default when it's not on the page.
        if (!document.getElementById('gj-flavor-mix')) {
          var mix = selOpt.getAttribute('data-pack-mix');
          if (mix) {
            var mixInput = form.querySelector('input[name="properties[Flavor Mix]"]');
            if (!mixInput) {
              mixInput = document.createElement('input');
              mixInput.type = 'hidden';
              mixInput.name = 'properties[Flavor Mix]';
              form.appendChild(mixInput);
            }
            mixInput.value = mix;
          }
        }
      }
      addToCart(vid, qty, atcBtn, plan);
    });
  }

  /* Sticky ATC */
  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener('click', function() {
      addToCart(parseInt(stickyAtcBtn.dataset.variantId, 10), 1, stickyAtcBtn);
    });
  }

  /* Sticky bar visibility */
  var stickyBar = qs('#gj-sticky-atc');
  if (atcBtn && stickyBar) {
    new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (!e.isIntersecting) {
          stickyBar.removeAttribute('hidden');
          stickyBar.setAttribute('aria-hidden', 'false');
          requestAnimationFrame(function() { stickyBar.classList.add('is-visible'); });
        } else {
          stickyBar.classList.remove('is-visible');
          setTimeout(function() {
            stickyBar.setAttribute('hidden', '');
            stickyBar.setAttribute('aria-hidden', 'true');
          }, 260);
        }
      });
    }, { threshold: 0 }).observe(atcBtn);
  }

  /* ─── Cart Drawer ────────────────────────────────── */
  var drawer      = qs('#gj-cart-drawer');
  var overlay     = qs('#gj-cart-overlay');
  var closeBtn    = qs('#gj-cart-close');
  var itemsEl     = qs('#gj-cart-items');
  var footEl      = qs('#gj-cart-foot');
  var emptyEl     = qs('#gj-cart-empty');
  var subtotalEl  = qs('#gj-cart-subtotal');
  var upsellEl    = qs('#gj-cart-upsell');
  var upsellProd  = qs('#gj-upsell-product');
  var drawerShip  = qs('#gj-drawer-ship');
  var drawerShipText = qs('#gj-drawer-ship-text');
  var freeThreshold  = productData.freeShipThreshold || 7500;

  function openCartDrawer() {
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCartDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function() { drawer.setAttribute('hidden', ''); }, 320);
  }

  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (overlay)  overlay.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeCartDrawer(); });
  document.addEventListener('cart:open', openCartDrawer);
  document.addEventListener('cart:refresh', refreshCart);

  function refreshCart() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(renderCart)
      .catch(function(e) { console.error('GJ cart refresh error:', e); });
  }

  function renderCart(cart) {
    if (!itemsEl) return;

    /* Shipping bar */
    if (drawerShip) {
      var remaining = freeThreshold - cart.total_price;
      if (drawerShipText) {
        drawerShipText.textContent = remaining <= 0
          ? 'Free shipping unlocked. Nice move.'
          : 'Add ' + fmtMoney(remaining) + ' more for free shipping';
      }
    }

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '';
      if (footEl)  footEl.hidden  = true;
      if (emptyEl) emptyEl.hidden = false;
      if (upsellEl) upsellEl.hidden = true;
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    if (footEl)  footEl.hidden  = false;
    if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function(item) {
      var img = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url.replace(/(\.\w+)$/, '_120x$1') + '" alt="' + (item.title || '') + '" width="64" height="64" loading="lazy">'
        : '';
      var planName = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.name) || '';
      return '<div class="gj-cart-item" data-key="' + item.key + '">'
        + '<div class="gj-cart-item__img">' + img + '</div>'
        + '<div class="gj-cart-item__info">'
        + '<div class="gj-cart-item__title">' + item.product_title + '</div>'
        + (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="gj-cart-item__variant">' + item.variant_title + '</div>' : '')
        + (planName ? '<div class="gj-cart-item__sub">🔁 ' + planName + '</div>' : '')
        + '<div class="gj-cart-item__bottom">'
        + '<span class="gj-cart-item__price">' + fmtMoney(item.line_price) + '</span>'
        + '<div class="gj-cart-item__qty">'
        + '<button class="gj-cart-item__qty-btn" data-action="minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Remove one ' + item.product_title + '">−</button>'
        + '<span class="gj-cart-item__qty-val">' + item.quantity + '</span>'
        + '<button class="gj-cart-item__qty-btn" data-action="plus"  data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Add one more ' + item.product_title + '">+</button>'
        + '</div>'
        + '</div>'
        + '<button class="gj-cart-item__remove" data-key="' + item.key + '" data-qty="0">Remove</button>'
        + '</div>'
        + '</div>';
    }).join('');

    /* Cart item qty/remove handlers */
    qsa('.gj-cart-item__qty-btn, .gj-cart-item__remove', itemsEl).forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.key;
        var qty = parseInt(btn.dataset.qty, 10);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
        .then(function(r) { return r.json(); })
        .then(renderCart)
        .catch(function(e) { console.error('GJ cart change error:', e); });
      });
    });

    /* Upsell */
    if (upsellEl && upsellProd && productData.id) {
      fetch('/recommendations/products.json?product_id=' + productData.id + '&limit=4')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (!data.products || !data.products.length) { upsellEl.hidden = true; return; }
          var inCart = cart.items.map(function(i) { return i.product_id; });
          var pick   = data.products.find(function(p) { return inCart.indexOf(p.id) === -1; });
          if (!pick) { upsellEl.hidden = true; return; }
          var img = pick.images && pick.images.length
            ? '<img src="' + pick.images[0].src.replace(/(\.\w+)$/, '_120x$1') + '" alt="' + pick.title + '" width="52" height="52" loading="lazy">'
            : '';
          var price = pick.variants && pick.variants.length ? fmtMoney(pick.variants[0].price) : '';
          var vid   = pick.variants && pick.variants.length ? pick.variants[0].id : 0;
          upsellProd.innerHTML = '<div class="gj-cart-upsell__img">' + img + '</div>'
            + '<div class="gj-cart-upsell__info">'
            + '<div class="gj-cart-upsell__name">' + pick.title + '</div>'
            + '<div class="gj-cart-upsell__price">' + price + '</div>'
            + '</div>'
            + '<button class="gj-cart-upsell__add" data-vid="' + vid + '" aria-label="Add ' + pick.title + ' to cart">+ Add</button>';
          upsellEl.hidden = false;
          var addBtn = upsellProd.querySelector('.gj-cart-upsell__add');
          if (addBtn) {
            addBtn.addEventListener('click', function() {
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ id: parseInt(addBtn.dataset.vid, 10), quantity: 1 })
              })
              .then(function(r) { return r.json(); })
              .then(refreshCart)
              .catch(function(e) { console.error('GJ upsell add error:', e); });
            });
          }
        })
        .catch(function() { upsellEl.hidden = true; });
    }
  }

  /* ─── Accordions ─────────────────────────────────── */
  qsa('.gj-accordion__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      var panel    = qs('#' + trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.hidden = expanded;
    });
  });

  /* ─── Recommendations with Quick-Add ────────────── */
  var recsGrid = qs('#gj-recs-grid');
  if (recsGrid && productData.id) {
    fetch('/recommendations/products.json?product_id=' + productData.id + '&limit=4')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products || !data.products.length) return;
        var html = data.products.map(function(p) {
          var img = p.images && p.images.length
            ? '<img src="' + p.images[0].src.replace(/(\.\w+)$/, '_500x$1') + '" alt="' + (p.images[0].alt || p.title) + '" width="500" height="500" loading="lazy">'
            : '';
          var price = p.variants && p.variants.length ? fmtMoney(p.variants[0].price) : '';
          var vid   = p.variants && p.variants.length ? p.variants[0].id : 0;
          var avail = p.variants && p.variants[0] && p.variants[0].available;
          return '<div class="gj-rec-card">'
            + '<a href="' + p.url + '" class="gj-rec-card__link" aria-label="View ' + p.title + '">'
            + '<div class="gj-rec-card__img-wrap">' + img + '</div>'
            + '</a>'
            + '<span class="gj-rec-card__title">' + p.title + '</span>'
            + '<span class="gj-rec-card__price">' + price + '</span>'
            + (avail
              ? '<button class="gj-btn gj-btn--atc gj-btn--quick-add" data-vid="' + vid + '" aria-label="Add ' + p.title + ' to cart">+ Grab It</button>'
              : '<button class="gj-btn gj-btn--sold-out gj-btn--quick-add" disabled>Gone</button>')
            + '</div>';
        }).join('');
        recsGrid.innerHTML = html;

        /* Quick-add handlers */
        qsa('.gj-btn--quick-add:not([disabled])', recsGrid).forEach(function(btn) {
          btn.addEventListener('click', function() {
            var vid = parseInt(btn.dataset.vid, 10);
            btn.textContent = 'Adding...';
            btn.setAttribute('aria-busy', 'true');
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ id: vid, quantity: 1 })
            })
            .then(function(r) { return r.json(); })
            .then(function() { btn.textContent = '✓ Added'; btn.removeAttribute('aria-busy'); document.dispatchEvent(new CustomEvent('cart:refresh')); })
            .catch(function() { btn.textContent = '+ Grab It'; btn.removeAttribute('aria-busy'); });
          });
        });
      })
      .catch(function() {});
  }

  /* ─── PDP free shipping nudge update on cart change ─ */
  document.addEventListener('cart:refresh', function() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        currentCartTotal = cart.total_price || 0;
        refreshShipPreview();
      })
      .catch(function() {});
  });

  /* ─── Sync ship bars from /cart.js on page load ─── */
  function syncShipFromCart() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        currentCartTotal = cart.total_price || 0;
        refreshShipPreview();
      })
      .catch(function() { refreshShipPreview(); });
  }
  /* Initial paint uses Liquid-known cart total; then async cart fetch confirms */
  refreshShipPreview();
  syncShipFromCart();

  /* Subscription selector removed - Recharge handles this via app block on the PDP */
  var sellingPlanIn = null;

})();
